import * as Sentry from '@sentry/nextjs'
import { createHttpClient, getErrorMapper } from '@systemeio/util'
import { isAxiosError } from 'axios'

export const httpClient = createHttpClient()

httpClient.interceptors.response.use(response => response, getErrorMapper(httpClient))

// Registered after the error mapper, so a 401 reaches it only when the mapper turned it into
// neither an `UnauthorizedResponse` redirect nor a successful replay after a token regenerate.
// A replay's 401 that reaches it is captured twice, in the replay's chain and in the replayed
// request's; replays were captured this way before sc-125473 too, so it is left as is
httpClient.interceptors.response.use(undefined, error => {
  if (isAxiosError(error) && error.response?.status === 401) {
    Sentry.captureMessage('Unauthorized response', {
      level: 'error',
      extra: { responseData: error.response.data },
    })
  }
  throw error
})

httpClient.interceptors.response.use(response => {
  if (response.status === 202 && response.config?.method === 'get') {
    Sentry.captureMessage('Unexpected 202 response', {
      level: 'info',
      extra: { url: response.config.url, data: response.data },
    })
  }
  return response
})
